import React, { Component } from 'react'
import { connect } from 'react-redux'
import UploadAccumulator from './UploadAccumulator'
import ReactMarkdown from 'components/Markdown/Markdown'
import Repeater from 'components/Wizard2/fieldComponents/Repeater'
import { STATIC_FIELD_IDS } from '../staticFields'
import './UploadAndSubmit.scss'
import shortid from 'shortid'

const UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION =
  process.env.UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION || false
const THIRD_PARTY_SIGNING_ALLOWED = process.env.THIRD_PARTY_SIGNING_ALLOWED

class UploadAndSubmit extends Component {

  id = `id-${shortid.generate()}`;

  select = (method, e) => {
    this.props.onChange({ ...this.props.value, method }, e)
  }
  setFiles = (files, e) => {
    this.props.onChange({ ...this.props.value, files })
  }
  setSigners = (signers, e) => {
    this.props.onChange({ ...this.props.value, signers })
  }
  getShouldShowTabs = () => {
    if (
      UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION &&
      (!this.props.allowOnline || !this.props.allowPrint || this.props.printMailRequired)
    ) {
      return false
    }
    return true
  }
  renderThirdPartySigners(isDisabled, method) {
    if (
      THIRD_PARTY_SIGNING_ALLOWED &&
      this.props.allowSigners &&
      this.props.thirdPartySigningAllowed
    ) {
      return (
        <Selectable
          parentId={this.id}
          controls="submit-panel-signers"
          disabled={isDisabled}
          selected={method === 'signer'}
          onClick={(e) => {
            this.select('signer', e)
          }}
          title={this.props.signerTabLabel || 'Send for Signatures'}
        />
      )
    } else {
      return null
    }
  }
  render() {
    const {
      allowMultipleSigners,
      allowOnline,
      allowPrint,
      canChangeCorrectionEntryType,
      canChangeEntryType,
      correctionMode,
      disabled,
      errorMessage,
      fieldId,
      mailInstructions,
      onlineInstructions,
      onlineTabLabel,
      printMailRequired,
      printTabLabel,
      readOnly,
      signerInstructions,
      template,
      value,
    } = this.props
    const method = printMailRequired ? 'mail' : value.method
    const isDisabled = readOnly
      ? !(canChangeEntryType && !printMailRequired)
      : correctionMode
        ? canChangeCorrectionEntryType === false
          ? true
          : disabled
        : disabled

    return (
      <div className="upload-submit" id={this.id}>
        {this.getShouldShowTabs() && (
          <div className="selectables" role="tablist" aria-label="Filing Options">
            {allowOnline && !printMailRequired && (
              <Selectable
                parentId={this.id}
                controls="submit-panel-online"
                disabled={isDisabled || printMailRequired}
                selected={method === 'online'}
                onClick={(e) => {
                  this.select('online', e)
                }}
                title={onlineTabLabel || 'File Online'}
              />
            )}
            {allowPrint && (
              <Selectable
                parentId={this.id}
                controls="submit-panel-mail"
                disabled={isDisabled}
                selected={method === 'mail'}
                onClick={(e) => {
                  this.select('mail', e)
                }}
                title={printTabLabel || 'Print and Mail'}
              />
            )}
            {this.renderThirdPartySigners(isDisabled, method)}
          </div>
        )}
        <div>
          {method === 'online' && (
            <OnlinePanel
              disabled={disabled}
              instructions={onlineInstructions}
              value={value.files}
              fieldId={fieldId}
              errorMessage={errorMessage}
              onChange={this.setFiles}
            />
          )}
          {method === 'mail' && <MailPanel disabled={disabled} instructions={mailInstructions} />}
          {method === 'signer' && (
            <SignerPanel
              disabled={disabled}
              instructions={signerInstructions}
              value={value.signers}
              fieldId={fieldId}
              errorMessage={errorMessage}
              onChange={this.setFiles}
              onRepeaterChange={this.setSigners}
              template={template}
              allowMultipleSigners={allowMultipleSigners}
            />
          )}
        </div>
      </div>
    )
  }
}
export default connect((state) => ({
  canChangeCorrectionEntryType: state.wizard.canChangeCorrectionEntryType,
  canChangeEntryType: state.wizard.canChangeEntryType,
  correctionMode: state.wizard.correctionMode,
  previewMode: state.wizard.preview,
  printMailRequired: state.wizard.requirePrintMailMethod.size > 0,
  readOnly: state.wizard.readOnly,
  thirdPartySigningAllowed: state.wizard.thirdPartySigningAllowed,
}))(UploadAndSubmit)

class OnlinePanel extends Component {
  render() {
    const { onChange, value, fieldId, errorMessage, instructions, disabled } = this.props
    return (
      <div id="submit-panel-online" className="no-outline" tabIndex="0" role="tabpanel" aria-labelledby="submit-panel-online-tab">
        <Panel >
          <ReactMarkdown source={instructions} className="markdown" />
          <UploadAccumulator
            disabled={disabled}
            value={value}
            parent={{ type: 'UploadAndSubmit', id: fieldId }}
            errorMessage={errorMessage}
            fieldId={fieldId}
            onChange={onChange}
          />
        </Panel>
      </div>
    )
  }
}

class MailPanel extends Component {
  render() {
    const { instructions, disabled } = this.props
    return (
      <div id="submit-panel-mail" className="no-outline" tabIndex="0" role="tabpanel" aria-labelledby="submit-panel-mail-tab">
        <Panel>
          <ReactMarkdown source={instructions} className="markdown" />
          <UploadAccumulator disabled={disabled} viewOnly />
        </Panel>
      </div>
    )
  }
}

class SignerPanel extends Component {
  render() {
    const {
      allowMultipleSigners,
      disabled,
      errorMessage,
      fieldId,
      instructions,
      onChange,
      onRepeaterChange,
      template,
      value = [],
    } = this.props
    return (
      <div id="submit-panel-signers" className="no-outline" tabIndex="0" role="tabpanel" aria-labelledby="submit-panel-signers-tab">
        <Panel>
          <ReactMarkdown source={instructions} className="markdown" />
          <UploadAccumulator
            disabled={disabled}
            value={value}
            parent={{ type: 'UploadAndSubmit', id: fieldId }}
            errorMessage={errorMessage}
            fieldId={fieldId}
            onChange={onChange}
          />
          <div className="repeater-wrapper">
            <Repeater
              template={[STATIC_FIELD_IDS.SIGNER_NAME, STATIC_FIELD_IDS.SIGNER_EMAIL, ...template]}
              value={value}
              onChange={onRepeaterChange}
              addButtonLabel="Add Signer"
              emptyRepeaterLabel="No signers have been added"
              maxRepeaterRows={allowMultipleSigners ? undefined : 1}
            />
          </div>
        </Panel>
      </div>
    )
  }
}

class Selectable extends Component {
  getTabs = () => {
    return Array.from(document.querySelectorAll(`#${this.props.parentId} .selectable`));
  }
  keydownEventListener = (event) => {
    var key = event.keyCode;
    switch (key) {
      case 35:
        event.preventDefault();
        this.focusLastTab();
        break;
      case 36:
        event.preventDefault();
        this.focusFirstTab();
        break;
      //up and down are handled to prevent page scroll
      case 38:
      case 40:
        this.switchTabOnArrowPress(event);
    }
  }
  keyupEventListener = (event) => {
    var key = event.keyCode;
    switch (key) {
      case 37:
      case 39:
        this.switchTabOnArrowPress(event);
        break;
      case 13:
      case 32:
        this.activateTab(event.target);
        break;
    }
  }
  switchTabOnArrowPress = (event) => {
    const tabs = this.getTabs();
    const direction = {
      37: -1,
      39: 1,
    }[event.keyCode]
    var pressed = event.keyCode;
    if (direction) {
      var currentTabIndex = tabs.findIndex((tab) => this.tab === tab)
      var targetTab = tabs[currentTabIndex + direction];
      if (targetTab) {
        targetTab.focus()
      }
      else if (pressed === 37) {
        this.focusLastTab();
      }
      else if (pressed === 39) {
        this.focusFirstTab();
      }
    }
  }
  activateTab = (tab, setFocus) => {
    setFocus = setFocus || true;
    this.deactivateTabs();
    tab.removeAttribute('tabindex');
    tab.setAttribute('aria-selected', 'true');
    if (setFocus) {
      tab.focus();
    }
  }
  deactivateTabs = () => {
    const tabs = this.getTabs()
    for (var t = 0; t < tabs.length; t++) {
      tabs[t].setAttribute('tabindex', '-1');
      tabs[t].setAttribute('aria-selected', 'false');
    }
  }
  focusFirstTab = () => {
    const tabs = this.getTabs()
    tabs[0].focus();
  };
  focusLastTab = () => {
    const tabs = this.getTabs()
    tabs[tabs.length - 1].focus();
  };

  render() {
    const { title, selected, onClick, disabled, controls } = this.props
    return (
      <button
        ref={ref => this.tab = ref}
        disabled={disabled}
        tabIndex={selected ? 0 : -1}
        className={`selectable ${selected ? 'selected' : ''} ${disabled ? 'disabled' : ''}`}
        onClick={onClick}
        aria-selected={selected}
        aria-controls={controls}
        role="tab"
        id={controls + '-tab'}
        onKeyDown={this.keydownEventListener}
        onKeyUp={this.keyupEventListener}
      >
        <div className="radio" />
        <span className="title">{title}</span>
      </button>
    )
  }
}

class Panel extends Component {
  render() {
    const { children, id } = this.props
    return <div className="panel" id={id}>{children}</div>
  }
}



// WEBPACK FOOTER //
// ./src/components/Wizard2/fieldComponents/UploadAndSubmit.js